var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarsGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 48,
    viewBox: "0 0 46 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 84"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 87"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Star 1",
    d: "M26.0921 0.335301C26.2576 -0.111767 26.8899 -0.111767 27.0553 0.335302L28.7398 4.88743C30.8202 10.5097 35.253 14.9425 40.8753 17.0229L45.4274 18.7074C45.8745 18.8728 45.8745 19.5051 45.4274 19.6706L40.8753 21.355C35.253 23.4354 30.8202 27.8682 28.7398 33.4905L27.0553 38.0426C26.8899 38.4897 26.2576 38.4897 26.0921 38.0426L24.4077 33.4905C22.3273 27.8682 17.8945 23.4354 12.2722 21.355L7.72007 19.6706C7.273 19.5051 7.273 18.8728 7.72007 18.7074L12.2722 17.0229C17.8945 14.9425 22.3273 10.5097 24.4077 4.88742L26.0921 0.335301Z",
    fill: "#0B4598"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 2",
    d: "M7.13383 32.5396C7.19691 32.3692 7.43804 32.3692 7.50113 32.5396L8.14347 34.2755C8.93681 36.4195 10.6272 38.1099 12.7712 38.9033L14.5071 39.5456C14.6776 39.6087 14.6776 39.8498 14.5071 39.9129L12.7712 40.5552C10.6272 41.3486 8.93681 43.039 8.14347 45.183L7.50113 46.9189C7.43804 47.0893 7.19691 47.0893 7.13383 46.9189L6.49149 45.183C5.69814 43.039 4.00774 41.3486 1.86376 40.5552L0.127863 39.9129C-0.0426211 39.8498 -0.0426209 39.6087 0.127863 39.5456L1.86376 38.9033C4.00774 38.1099 5.69814 36.4195 6.49149 34.2755L7.13383 32.5396Z",
    fill: "#0B4598"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsGroup);
export default __webpack_public_path__ + "static/media/starsGroup.25b283d5463a5889e489e008ad9307a9.svg";
export { ForwardRef as ReactComponent };